import React, { useContext } from "react";
import { SingleDates, Box } from "@flexisaf/flexibull2";
import styled from "styled-components";

import { SchemaContext } from "../container";
import { InputError, InputWrapper } from "../input-wrapper";

const FieldStack = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: 0;

  @media (max-width: 600px) {
    max-width: calc(100vw - 100px);
  }
`;

const FieldLabel = styled.label`
  display: block;
  position: static;
  margin: 0 0 0.4rem;
  padding: 0;
  font-size: 0.78rem;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
  color: #5a5368;
  line-height: 1.35;
`;

const SingeDate = (props) => {
  const { disabledFields, fieldValue, errorFields, updateFieldValue } =
    useContext(SchemaContext);

  const isValidDate = (d) => d instanceof Date && !isNaN(d);

  const Re = (val) => {
    if (disabledFields.includes(props.keyField)) return;
    if (isValidDate(val)) updateFieldValue(props.keyField, val);
  };

  return (
    <FieldStack>
      <InputWrapper {...props}>
        {props.props.label ? (
          <FieldLabel>
            {props.props.label}{" "}
            {props.props?.required ? (
              <span style={{ color: "red" }}>*</span>
            ) : null}
          </FieldLabel>
        ) : null}
        <SingleDates
          name={props.keyField}
          dayPlaceholder="day"
          monthPlaceholder="month"
          yearPlaceholder="year"
          dayGap="10px"
          yearGap="10px"
          disabled={disabledFields.includes(props.keyField)}
          value={
            fieldValue?.[props.keyField]
              ? new Date(fieldValue?.[props.keyField])
              : null
          }
          onDateChange={Re}
        />
        <InputError>{errorFields[props.keyField]}</InputError>
      </InputWrapper>
    </FieldStack>
  );
};

export default SingeDate;
